import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Country  {
    _originalTypeClassName = "ekylikeio.BO.Country";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Country.translate = translateService;
}
this.Holidays = [];
this.Id = null;
this.ISO2Code = null;
this.ISO3Code = null;
this.Name = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ISO2Code:any;
ISO3Code:any;
Name:any;
Holidays:any;
static setHolidays = ($this, items) => {
                if (items == null) items = [];
                if ($this.Holidays == null) $this.Holidays = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Holidays.length > 0) {
                    Domain.Country.removeHolidays($this, $this.Holidays[0]);
                }

                Domain.Country.addManyHolidays($this, copyItems);
            }
static addManyHolidays = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Country.addHolidays($this, items[i]);
                }
            }
static addHolidays = ($this, item) => {
                if ($this.Holidays == null) $this.Holidays = [];
                if (item == null || $this.Holidays.indexOf(item) > -1) return;
                $this.Holidays.push(item);
if (item.Country != $this) {
Domain.CountryHoliday.setCountry(item, $this);
}
}
static addRangeHolidays = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Country.addHolidays($this, item));
            }
static removeHolidays = ($this, item) => {
                if ($this == null || $this.Holidays == null || $this.Holidays.indexOf(item) === -1) return;
                var _index = $this.Holidays.indexOf(item);
                $this.Holidays.splice(_index, 1);
item.Country = null;
}
static clearHolidays = ($this) => { $this.Holidays = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}